import { configureStore } from "@reduxjs/toolkit";
import Reducer from "../reducer/slice";

const store = configureStore({
  reducer: {
    editor: Reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['editor.domRef'], // ignore this path in your slice
        ignoredActions: ['editor/setDomRef'], // ignore this action if needed
      },
    }),
});

export default store;
